import React, { useEffect, useState } from 'react'
import merge from 'lodash/merge'
import { ValidationContainerProps } from './ValidationContainer.types'

interface ValidtionInputType {
    [key: string]: {
        isValid: boolean
        isValidating: boolean
    }
}

class ValidationContainer extends React.Component<ValidationContainerProps, any> {
    constructor(props) {
        super(props)

        this.state = {
            inputs: {},
            isValid: false,
            invalidInputs: [],
        }
    }

    registerInput = ({ name, isValid, setShallValidate }, cb) => {
        this.setState(
            (prevState) => {
                const inputs = merge({}, prevState.inputs)
                inputs[name] = { isValid, setShallValidate }
                return { inputs }
            },
            () => {
                if (cb) {
                    cb()
                }
            },
        )
    }

    unregisterInput = ({ name, isValid }, cb) => {
        this.setState(
            (prevState) => {
                const inputs = merge({}, prevState.inputs)
                delete inputs[name]
                return { inputs }
            },
            () => {
                if (cb) {
                    cb()
                }
            },
        )
    }

    updateValidity = ({ name, isValid, isValidating }) => {
        this.setState((prevState) => {
            const inputs = merge({}, prevState.inputs)
            const input = inputs[name]

            if (input) {
                input.isValid = isValid
                input.isValidating = isValidating
                inputs[name] = input
            }

            return { inputs }
        })
    }

    validate = () => {
        let isValid = true
        const invalidInputs = []
        const { inputs } = this.state
        const keys = Object.keys(inputs)
        if (keys.length === 0) {
            return
        }
        keys.forEach((key) => {
            const input = inputs[key]
            if (!input.isValid || input.isValidating) {
                isValid = false
                invalidInputs.push(key)
            }
        })
        this.setState(() => {
            return { invalidInputs, isValid }
        })
    }

    getContext = () => {
        return {
            isValid: this.state.isValid,
            inputs: this.state.inputs,
            invalidInputs: this.state.invalidInputs,
            registerInput: this.registerInput,
            unregisterInput: this.unregisterInput,
            updateValidity: this.updateValidity,
        }
    }

    //Lifecycle
    componentDidMount() {
        const { validateOnSubmit } = this.props

        if (!validateOnSubmit) {
            this.validate()
        }

        if (this.props.onMount) {
            this.props.onMount(this.state.isValid, this.getContext())
        }
    }

    componentWillUnmount() {
        if (this.props.onUnMount) {
            this.props.onUnMount(this.state.isValid, this.getContext())
        }
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (JSON.stringify(this.state.inputs) !== JSON.stringify(prevState.inputs)) {
            this.validate()
        }

        if (this.props.onChange) {
            this.props.onChange(this.state.isValid, this.getContext())
        }
    }

    render() {
        return <React.Fragment>{this.props.children(this.getContext())}</React.Fragment>
    }
}

export default ValidationContainer
